import AgentesList from './AgentesList'

export default {
  list: AgentesList,
}
